import Config from './../config/app-configuration';
import utils from '../utils/utils';

export class ApiClient {
    static async fetchPostCall(serviceUrl, postData, requestHeaders) {
        await this.checkTokenValidity();
        const headers = (requestHeaders && Object.keys(requestHeaders).length) ? { ...requestHeaders } : { ...Config.headers, refreshToken: localStorage.getItem('refreshToken') };
        headers['Authorization'] = `Bearer ${sessionStorage.getItem('token')}`;

        const promise = await fetch(serviceUrl, {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: headers,
            credentials: "include"
        }).then(response => {
            if (response.status === 401) {
                utils.logoutStorage()
            }
            const token = response.headers.get('token');
            const refreshToken = response.headers.get('refreshToken');
            if (token) {
                utils.setCookie("Authorization", token, 1)
                sessionStorage.setItem('token', token);
            }
            if (refreshToken) {
                localStorage.setItem('refreshToken', refreshToken);
            }
            return response;
        })

        return promise;
    }

    


    static async fetchPostFormDataCall(serviceUrl, postData) {
        await this.checkTokenValidity();
        var headers = JSON.parse(JSON.stringify(Config.headers));
        delete headers['Content-Type'];
        headers['refreshToken'] = localStorage.getItem('refreshToken');
        headers['Authorization'] = `Bearer ${sessionStorage.getItem('token')}`;
        var promise = await fetch(serviceUrl, {
            method: 'POST',
            body: postData,
            headers: headers,
            credentials: "include"
        }).then(response => {
            if(response.status === 401){
                utils.logoutStorage()
            }
            const token = response.headers.get('token');
            const refreshToken = response.headers.get('refreshToken');
            if (token) {
                utils.setCookie("Authorization",token,1)
                sessionStorage.setItem('token', token);
            }
            if (refreshToken) {
                localStorage.setItem('refreshToken', refreshToken);
            }
            return response;
        })


        return promise;


    }
    static async fetchGetFormDataCall(serviceUrl) {
        await this.checkTokenValidity();
        var headers = JSON.parse(JSON.stringify(Config.headers));
        delete headers['Content-Type'];
        headers['refreshToken'] = localStorage.getItem('refreshToken');
        headers['Authorization'] = `Bearer ${sessionStorage.getItem('token')}`;
        var promise = await fetch(serviceUrl, {
            method: 'GET',
            headers: headers,
            credentials: "include"
        }).then(response => {
            if(response.status === 401){
                utils.logoutStorage()
            }
            const token = response.headers.get('token');
            const refreshToken = response.headers.get('refreshToken');
            if (token) {
                utils.setCookie("Authorization",token,1)
                sessionStorage.setItem('token', token);
            }
            if (refreshToken) {
                localStorage.setItem('refreshToken', refreshToken);
            }
            return response;
        })



        return promise;
    }
    static async fetchGetCall(serviceUrl) {
        await this.checkTokenValidity();
        var headers = Config.headers;
        headers['refreshToken'] = localStorage.getItem('refreshToken');
        headers['Authorization'] = `Bearer ${sessionStorage.getItem('token')}`;
        var promise = await fetch(serviceUrl, {
            method: 'GET',
            headers:headers,
            credentials: "include"
        }).then(response => {
            if(response.status === 401){
                utils.logoutStorage()
            }
            const token = response.headers.get('token');
            const refreshToken = response.headers.get('refreshToken');
            if (token) {
                utils.setCookie("Authorization",token,1)
                sessionStorage.setItem('token', token);
            }
            if (refreshToken) {
                localStorage.setItem('refreshToken', refreshToken);
            }
            return response;
        })


        return promise;
    }
    static async fetchPostCallUnAuth(serviceUrl, postData) {
        var headers = Config.headers;
        var promise = await fetch(serviceUrl, {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: headers,
            credentials: "include"
        })


        return promise;
    }
    static async fetchGetCallUnAuth(serviceUrl, additionalHeaders) {
        let headers = Config.headers;
        if(additionalHeaders) headers = {...headers, ...additionalHeaders};
        
        const promise = await fetch(serviceUrl, {
            method: 'GET',
            headers: headers,
            credentials: "include"
        })

        return promise;
    }
    static verifyTokenValidity(token) {
        if (!token) return false;
        try {
            var { exp } = JSON.parse(atob(token?.split('.')[1]));
            return (exp && exp >= (new Date().getTime() + 10000) / 1000)
        } catch (err) {
            return false;
        }
    }

    static getRefreshTokenLock() {
        return sessionStorage.getItem("refreshTokenLock");
    }

    static setRefreshTokenLock(value) {
        if (!value)
            sessionStorage.removeItem("refreshTokenLock");
        else
            sessionStorage.setItem("refreshTokenLock", value);
    }

    static async wait(time = 1200) {
        return new Promise(resolve => {
            setTimeout(function () { resolve(); }, time);
        });
    }

    static async checkTokenValidity() {
        try {
            let that = this;
            let refreshTokenLock = this.getRefreshTokenLock();
            let count = 0;

            // Wait for any ongoing refresh
            while (refreshTokenLock && count < 15) {
                await this.wait(count > 0 ? 200 * count : undefined);
                refreshTokenLock = that.getRefreshTokenLock();
                count += 1;
            }

            let token = sessionStorage.getItem('token');
            if (!this.verifyTokenValidity(token)) {
                await this.refreshToken();
            }
        } catch (e) {
            console.log(e);
        }
    }

    static async refreshToken() {

        const currRefreshToken = localStorage.getItem('refreshToken');
        this.setRefreshTokenLock(true);

        try {
            if (!this.verifyTokenValidity(currRefreshToken)) return utils.logoutApp();
            const serviceUrl = `${Config.baseUrl}${Config.refreshToken}`;
            const headers = {
                'Content-Type': 'application/json; charset=UTF-8',
                'Accept': '*/*',
            };
            headers['refreshToken'] = localStorage.getItem('refreshToken');

            await fetch(serviceUrl, {
                method: 'GET',
                headers: headers,
            }).then(async response => {
                if (response.status === 401) utils.logoutApp();

                const { id_token: token, refreshToken } = await response.json();

                if (token) sessionStorage.setItem('token', token);
                if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
            })
        }
        catch (err) {
            console.log(err);
            throw err;
        }
        finally {
            this.setRefreshTokenLock(false);
        }
    }
}

export default ApiClient;
